import { StyledAccordion } from './Accordion.styled';
import { AccordionProps } from './Accordion.types';
import AccordionItem from './AccordionItem';

const Accordion: React.FC<AccordionProps> = ({ items }) => {
  return (
    <StyledAccordion>
      {items?.map((item, index) => {
        return (
          <AccordionItem
            key={index}
            summary={item.summary}
            details={item.details}
            active={item.active}
          />
        );
      })}
    </StyledAccordion>
  );
};

export default Accordion;
